import { Component } from "react";
import styles from "../FormSubmissionReplies/FormSubmissionReplies.module.scss";
import { Input3, Button2, ThankYouSection, ErrorSection, Checkbox, BackButton } from "..";
import {
  STAGES,
} from "./constants";
import { EMAIL_REGEX, BEATBREAD_PRIVACY_POLICY } from "../../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import * as Yup from "yup";
import { ReactComponent as Arrows } from "../../assets/SVGs/double-chevron-right.svg";
import { TERM_OF_USE } from "../../routes/constants";
import { Form, Formik } from "formik";
import axios from "axios";

class PartnerForm extends Component {
  constructor() {
    super();
    this.state = {
      updatedFormData: {
        name: "",
        email: "",
        distributor: "",
        website: "",
        checked: false,
      },
      showAlert: false,
      alertText: "",
      stage: STAGES.INITIAL,
      loader: false,
    };
  }

  resetState = (additionalStates = {}) => {
    this.setState({
      updatedFormData: {
        name: "",
        email: "",
        distributor: "",
        website: "",
        checked: false,
      },
      showAlert: false,
      alertText: "",
      ...additionalStates,
    });
  };

  changeComponentErr = (alertText) => {
    return <ErrorSection onClick={this.renderInitial} subtitle={alertText} />;
  };

  changeComponentSuc = () => {
    return <ThankYouSection />;
  };

  emailValidation = () => EMAIL_REGEX;

  handleSubmit = async (values) => {
    this.setState({ loader: true });
    const params = new URLSearchParams(window.location.search);
    const hubspotLabel = params.get("label_id");
    const payload = {
      name: values.name,
      email: values.email,
      company_name: values.distributor,
      ...(values.website ? { company_website: values.website } : {}),
      ...(hubspotLabel ? { label_form_source: hubspotLabel } : {}),
    };
    axios
      .post(
        `${process.env.REACT_APP_HUBSPOT_API_URL}/hubspot/distributor_contact/`,
        payload
      )
      .then((res) => {
        console.log("Success:", res ? res : "No response");
        this.setState({ loader: false });
        this.setState({ stage: "success" });
      })
      .catch((err) => {
        console.error("Error:", err);
        this.setState({ loader: false });
          this.setState({ alertText: err.message });
          this.setState({ stage: "error" });
      })
      .finally(() => {
        this.resetState();
      });
  };

  handleBackNavigation = () => {
    if (this.state.stage !== STAGES.INITIAL) {
      return (
        <BackButton onClick={() => this.setState({ stage: STAGES.INITIAL })} />
      );
    }
  };

  renderWidgetForm = () => (
    <Formik
      initialValues={this.state.updatedFormData}
      validationSchema={this.formikValidation}
      onSubmit={this.handleSubmit}
    >
      <Form className={styles.widgetBoxForm}>
        <div className={styles.heading}>
          <p className={styles.ogSubtitle}>
            Interested in partnering with beatBread?
          </p>
          <h2 className={styles.ogTitle}>
            Please share a few details and we'll be in touch.
          </h2>
        </div>
        <div className={styles.form}>
          <Input3
            label="Contact Name"
            name="name"
            autoComplete="name"
            placeholder="Ex. John Doe"
            disabled={this.state.loader}
          />
          <Input3
            label="Email Address"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="johndoe@email.com"
            disabled={this.state.loader}
          />
          <Input3
            label="Distributor Name"
            name="distributor"
            autoComplete="organization"
            placeholder="beatBread"
            disabled={this.state.loader}
          />
          <Input3
            label="Website"
            name="website"
            autoComplete="url"
            optional
            placeholder="https://www.beatbread.com"
            disabled={this.state.loader}
          />
        </div>
        <div className={styles.checkboxClass}>
          <Checkbox input="checkbox" name="checked"> 
            <div className={styles.checkLabel}>
              I agree to beatBread’s{" "}
              <a href={TERM_OF_USE} target="_blank" rel="noreferrer">
                Terms of Service
              </a>{" "}
              and acknowledge beatBread’s{" "}
              <a href={BEATBREAD_PRIVACY_POLICY} target="_blank" rel="noreferrer">
                Privacy Notice
              </a>
              . I consent to receive beatBread messages via SMS. Standard call,
              message, or data rates may apply.
            </div>
          </Checkbox>
        </div>
        <Button2
          full
          className={styles.submit}
          type="submit"
          disabled={this.state.loader}
        >
          {this.state.loader ? (
            <FontAwesomeIcon icon={faCircleNotch} className="spin" />
          ):(<><p>SUBMIT</p> <Arrows /></>)}
        </Button2>
      </Form>
    </Formik>
  );

  renderInitial = () =>
    this.setState({
      stage: STAGES.INITIAL,
    });

  formikValidation = Yup.object().shape({
    name: Yup.string().label("Contact Name").required(),
    email: Yup.string()
      .label("Email")
      .required()
      .matches(EMAIL_REGEX, "Please enter valid email"),
    distributor: Yup.string().label("Distributor Name").required(),
    checked: Yup.bool().required().oneOf(
      [true],
      "Please agree to the Privacy Policy before proceeding."
    ),
  });

  setStage = () => {
    switch (this.state.stage) {
      case STAGES.INITIAL:
        return this.renderWidgetForm();
      case STAGES.SUCCESS:
        return this.changeComponentSuc();
      case STAGES.ERROR:
        return this.changeComponentErr(this.state.alertText);
      default:
        return this.renderWidgetForm();
    }
  }

  render() {
    return (
      <div className={styles.DealCompForm}>
        {this.setStage()}
        {this.handleBackNavigation()}
      </div>  
    );
  }
}

export default PartnerForm;
